import React from 'react';

import { Spinner } from 'AWS-UI-Components-React';
import { MaxHeightContainerWith80vh } from '../../styles/common_styles';
import { hashCode } from '../../utilities';
import logger from '../../utils/logging';
import { getJSClient } from '../js_client';

import { SimulationDetails } from './simulation_details';
import { SimulationGraph } from './simulation_graph';
import { SimulationsList } from './simulations_list';
import { SIMULATION_DETAILS_VIEW, SIMULATION_VALIDATION_VIEW } from '../../constants/views';
import { ValidationTestResultsView } from './validation_test_results/validation_test_results_view';
import { ApiInvocationStatus } from '../../constants/constants';

export class SimulationDetailsView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      marketplaceItems: {},
      productLinesByIdMap: this.props.productLinesByIdMap || {},
    };
  }
  componentDidMount = () => {
    this.client = getJSClient();
    this.client.getMarketplaceConfig(this.onMarketplaceConfigFetchSuccess);
  };

  onMarketplaceConfigFetchSuccess = (response) => {
    try {
      const marketplaceConfigs = JSON.parse(response.marketplaceConfig).filter((mp) => mp.enabled);
      let marketplaceItems = [];
      marketplaceConfigs.forEach((mp) => marketplaceItems.push({ label: mp.detail, value: mp.detail, id: mp.id }));
      this.setState({ marketplaceItems });
    } catch (e) {
      logger.error('MarketplaceConfig fetch failed', e);
    }
  };

  render() {
    const {
      simulations,
      user,
      identity,
      selectedSimulation,
      selectedSimulationDetails,
      onSelection,
      refreshIndex,
      selectedSegmentId,
      status,
      validationTestResults,
      selectedSimulationRuntime,
      filteringTokens,
    } = this.props;

    return (
      <div className={MaxHeightContainerWith80vh}>
        <div className="awsui-grid">
          <div className="awsui-row">
            <div className="col-3">
              <div className={MaxHeightContainerWith80vh}>
                <SimulationsList
                  key={hashCode(simulations)}
                  onSelectionChange={onSelection}
                  simulations={simulations}
                  selected={selectedSimulation}
                  status={status}
                  filteringTokens={filteringTokens}
                  onFilteringTokensChange={this.props.onFilteringTokensChange}
                />
              </div>
            </div>
            {ApiInvocationStatus.IN_PROGRESS === status && (
              <div className="col-5">
                <Spinner size="large" />
              </div>
            )}
            {selectedSimulation && selectedSegmentId === SIMULATION_DETAILS_VIEW.id && (
              <div className="col-5">
                <SimulationDetails
                  key={selectedSimulation.id + selectedSimulation.currentStatus}
                  identity={identity}
                  user={user}
                  simulation={selectedSimulation}
                  status={status}
                  productLinesByIdMap = {this.state.productLinesByIdMap}
                />
              </div>
            )}
            {selectedSimulation && selectedSimulationDetails && selectedSegmentId === SIMULATION_DETAILS_VIEW.id && (
              <div className="col-4">
                <SimulationGraph
                  key={selectedSimulation.id + selectedSimulation.currentStatus + refreshIndex}
                  user={user}
                  id={selectedSimulation.id}
                  simulationDetails={selectedSimulationDetails}
                  status={status}
                  selectedSimulationRuntime={selectedSimulationRuntime}
                />
              </div>
            )}

            <div
              className="col-9"
              style={{
                display: selectedSimulation && selectedSegmentId === SIMULATION_VALIDATION_VIEW.id ? 'block' : 'none',
              }}
            >
              <ValidationTestResultsView
                validationTestResults={validationTestResults}
                simulation={selectedSimulation}
                marketplaceItems={this.state.marketplaceItems}
                loadValidationTestResults={this.props.loadValidationTestResults}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/simulator/simulation_details_view.jsx